<div class="bg-white summary-cards card-top">
    <div class="container py-3 pt-lg-0 px-lg-3 px-4">
        <div class="d-block d-md-none py-2">
            <div class="d-flex justify-content-between mb-1">
                <p class="mb-0 fw-sbold fs-16">Saldo disponible</p>
                <div class="d-flex align-items-center mx-3 cr-pointer" [routerLink]="path.ROUTE_MOVE_HOME_V2">
                    <img src="https://static.monific.com/assets/assets-app/img/wallet/arrow-icon.svg" class="rotate" alt="..">
                </div>
            </div>
            <div>
                <h3 class="cl-blue mb-1 fw-sbold" [countUp]="balance | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></h3>
                <p class="fs-12">Para invertir o retirar</p>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
            <div class="col d-md-grid d-none">
                <div class="pill">
                    <div class="square-img">
                        <img src="/assets/icons/home-wallet-2.svg" alt="..">
                    </div>
                    <div>
                        <p>Saldo disponible</p>
                        <p class="fw-sbold" [countUp]="balance | toNumber" [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="pill justify-content-between">
                    <div class="d-flex">
                        <div class="square-img">
                            <img src="/assets/icons/home-my-money.svg" alt="..">
                        </div>
                        <div>
                            <p>Dinero invertido</p>
                            <p class="fw-sbold" [countUp]="invested | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></p>
                        </div>
                    </div>
                    <!-- <div class="d-flex">
                        <div class="mini-pill d-none">
                            <p class="fs-7">15.96%</p>
                            <p class="fs-5-sm">Anual promedio</p>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col">
                <div class="pill justify-content-between">
                    <div class="d-flex">
                        <div class="square-img">
                            <img src="/assets/icons/home-chart-icon.svg" alt="..">
                        </div>
                        <div>
                            <p>Valor de mi cuenta</p>
                            <p class="fw-sbold" [countUp]="totalInvested | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></p>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="mini-pill cr-pointer" [routerLink]="path.ROUTE_AVAILABLE_PROJECTS_HOME">
                            <p class="fs-9" >Ir a invertir</p>
                        </div>
                        <div class="d-flex align-items-center cr-pointer ms-2 me-3" [routerLink]="path.ROUTE_MY_INVESTMENTS_HOME">
                            <img src="https://static.monific.com/assets/assets-app/img/wallet/arrow-icon.svg" class="rotate" alt="..">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="pill bg-blue">
                    <div class="square-img bg-primary">
                        <img src="/assets/icons/home-white-wallet.svg" alt="..">
                    </div>
                    <div>
                        <p>Has ganado</p>
                        <p class="fw-sbold cl-blue" [countUp]="totalEarnings | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>